import {format98To0} from '../../../../../utilities/helper/formatPhoneNumber';
import InfoRow from '../../../../shopping-basket/ItemCard/InfoRow';
interface IProps {
  storeName: string;
  state: string;
  city: string;
  address: string;
  storeNumber: string;
  isOrderCompleted: boolean;
}
const SellerInformation = ({
  storeName,
  state,
  city,
  address,
  storeNumber,
  isOrderCompleted,
}: Partial<IProps>) => {
  return (
    <div className="space-y-2">
      <span className="text-sm font-medium text-zinc-500">اطلاعات فروشنده</span>

      <div className="p-3 space-y-2 bg-zinc-100 rounded-xl">
        <InfoRow
          icon="icon-nameProfile"
          label="نام فروشگاه"
          value={storeName ?? 'مشخص نشده'}
        />
        <InfoRow
          icon="icon-nameLocation"
          label="استان / شهر"
          value={city && state ? `${state} / ${city}` : 'مشخص نشده'}
        />
        <InfoRow
          icon="icon-nameLocation"
          label="آدرس فروشگاه"
          value={
            address && Boolean(address?.trim()?.length) ? address : 'مشخص نشده'
          }
        />
        {isOrderCompleted ? (
          <InfoRow
            icon="icon-namecall"
            label="شماره تماس"
            value={storeNumber?.replace(/^98/, '0')}
          />
        ) : (
          <a
            href={`tel:${format98To0(storeNumber?.replace(/^98/, '0'))}`}
            className="block no-underline"
          >
            <InfoRow
              icon="icon-namecall"
              className="text-lime-700"
              labelClassName="text-lime-700"
              label="شماره تماس"
              value={storeNumber?.replace(/^98/, '0')}
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default SellerInformation;
